import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { runGuide } from './runner';

/** A callback that runs a tour by id from any button or link. Tours run in the sandbox. */
export function useGuide(): (guideId: string) => void {
  const navigate = useNavigate();
  const location = useLocation();
  return useCallback(
    (guideId: string) => {
      void runGuide(guideId, navigate, `${location.pathname}${location.search}`).then((ran) => {
        if (!ran) toast.error('That tour could not start.');
      });
    },
    [navigate, location.pathname, location.search],
  );
}
